import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TransactionModalComponent } from './transaction-modal/transaction-modal.component';
import { MonthSelectorComponent } from './month-selector/month-selector.component';
import { TitleComponent } from './title/title.component';
import { TransactionListComponent } from './transaction-list/transaction-list.component';
import { TransactionComponent } from './transaction/transaction.component';

@NgModule({
  imports: [IonicModule, CommonModule, ReactiveFormsModule],
  exports: [TitleComponent, MonthSelectorComponent, TransactionListComponent],
  declarations: [
    TitleComponent,
    MonthSelectorComponent,
    TransactionModalComponent,
    TransactionListComponent,
    TransactionComponent,
  ],
})
export class SharedComponentsModule {}
